<div class="activities-home">
  <div class="hero">
    <h1 class="hero-title">À l’Asso</h1>
    <h2 class="hero-subtitle">Des activités bénévoles près de chez vous</h2>
    <p class="hero-description">Explorez des opportunités de bénévolat adaptées à vos envies et à votre disponibilité.</p>
  </div>

  <div class="search-activities">
    <div class="input-container">
      @if (isMobile$ | async) {
        <app-activity-filter-search [resetFormTrigger]="resetFormTrigger" [mobileMode]="true" (searchFiltersChanged)="onSearchFiltersChanged($event)">
        </app-activity-filter-search>
      } @else {
        <app-activity-filter-search [resetFormTrigger]="resetFormTrigger" (searchFiltersChanged)="onSearchFiltersChanged($event)">
        </app-activity-filter-search>
      }
    </div>
    <app-activity-filter [resetFormTrigger]="resetFormTrigger" (selectedThemes)="onSelectedThemeChanges($event)"></app-activity-filter>
    <div class="switch-map">
      <app-toggle-menu [tabs]="navigationItems" [activeTabValue]="0" (chosenTab)="handleNavigation($event)"></app-toggle-menu>
    </div>
  </div>

  <div class="cards-and-map">
    <div class="cards-activities" [ngClass]="chosenNavigation !== 'Liste' ? 'hidden' : ''">
      <!-- skeletons for loading -->
      @if (!(activities$ | async)?.length) {
        <app-activity-skeleton></app-activity-skeleton>
        <app-activity-skeleton></app-activity-skeleton>
        <app-activity-skeleton></app-activity-skeleton>
        <app-activity-skeleton></app-activity-skeleton>
      } @else {
        @for (activity of filteredActivities$ | async; track activity.id) {
          <app-activity-card [activity]="activity" (deleteActivity)="onDeleteActivity($event)"> </app-activity-card>
        } @empty {
          <div class="empty">
            <p>Aucun résultat ne correspond à votre recherche</p>
            <button type="button" class="btn-reset" (click)="resetFiltersAndShowAll()">Voir toutes les activités</button>
          </div>
        }
      }
    </div>

    <div class="map-activities" [ngClass]="chosenNavigation !== 'Carte' ? 'hidden' : ''">
      <app-map [filteredActivities$]="filteredActivities$" (myCityClicked)="onMyCityClicked($event)"></app-map>
    </div>
  </div>
</div>
